import React, { useState, forwardRef, useImperativeHandle } from 'react';
import Menu from '@mui/material/Menu';

interface MenuButtonProps {
    buttonContent: () => React.ReactNode;
    children: React.ReactNode;
    classes?: {
        button: string;
        menu: string
    };
    isMobile: boolean;
}

export interface MenuButtonRef {
    closeMenu: () => void;
}

const MenuButton = forwardRef<MenuButtonRef, MenuButtonProps>((props, ref) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useImperativeHandle(ref, () => ({
        closeMenu: handleClose,
    }));

    return (
        <div>
            <button
                id='menu-button'
                className={props.classes?.button}
                type='button'
                onClick={handleClick}
            >
                {props.buttonContent()}
            </button>
            <Menu
                anchorEl={anchorEl}
                className={props.classes?.menu}
                open={open}
                onClose={handleClose}
                MenuListProps={{'aria-labelledby': 'menu-button'}}
            >
                {props.children}
            </Menu>
        </div>
    );
});

export default MenuButton;